// See: https://github.com/FortAwesome/react-fontawesome#build-a-library-to-reference-icons-throughout-your-app-more-conveniently
import { library } from '@fortawesome/fontawesome-svg-core';

import { faSave } from '@fortawesome/free-regular-svg-icons/faSave';
import { faMosque } from '@fortawesome/free-solid-svg-icons/faMosque';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faUndo } from '@fortawesome/free-solid-svg-icons/faUndo';
import { faChartLine } from '@fortawesome/pro-duotone-svg-icons/faChartLine';
import { faFileImport } from '@fortawesome/pro-duotone-svg-icons/faFileImport';
import { faListOl } from '@fortawesome/pro-duotone-svg-icons/faListOl';
import { faSirenOn } from '@fortawesome/pro-duotone-svg-icons/faSirenOn';
import { faUsers } from '@fortawesome/pro-duotone-svg-icons/faUsers';
import { faPencilAlt } from '@fortawesome/pro-light-svg-icons/faPencilAlt';
import { faExchangeAlt } from '@fortawesome/pro-light-svg-icons/faExchangeAlt';
import { faRouter } from '@fortawesome/pro-light-svg-icons/faRouter';
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { faShieldAlt } from '@fortawesome/pro-regular-svg-icons/faShieldAlt';
import { faClone } from '@fortawesome/free-solid-svg-icons/faClone';
import { faRecycle } from '@fortawesome/free-solid-svg-icons/faRecycle';

import React from 'react';
import { faEraser } from '@fortawesome/free-solid-svg-icons';

const IconLibrary = React.memo(() => {
    // Icons for the Navigation Drawer
    library.add(faChartLine, faFileImport, faListOl, faMosque, faRouter, faSirenOn, faShieldAlt, faUsers);

    // Icons for Action Buttons
    library.add(faPencilAlt, faPlus, faSave, faTimes, faTrash, faUndo, faExchangeAlt, faClone, faRecycle, faEraser);

    return null;
});

export default IconLibrary;
